import { PrinterError } from '@/features/print/errors'
import { logger } from '@/features/print/logger'
import { printToPrinters } from '@/features/print/printToPrinters'
import { PrintEntry } from '@/features/print/types'
import { printersSelectors } from '@/redux/reducers/printers/selectors'
import { RootState } from '@/redux/store'
import { ThunkRejectValue } from '@/redux/types'
import { getThunkRejectValue } from '@/redux/utils'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const printByType = createAsyncThunk<
    { successCount: number; failureCount: number },
    PrintEntry,
    { state: RootState; rejectValue: ThunkRejectValue }
>('printByType', async (entry, { getState, rejectWithValue }) => {
    try {
        const state = getState()
        const eligiblePrinters = printersSelectors.printersByPrintJobType(entry.printType)(state)

        const result = await printToPrinters(entry, eligiblePrinters)

        result.failures.forEach((f) => {
            if (f.error instanceof PrinterError) return

            logger
                .withMetadata({ extras: { printEntry: entry } })
                .withError(f.error)
                .error(
                    `Failed to print ${entry.printType} on ${f.printer.connectionOptions.type} printer.`
                )
        })

        return { successCount: result.successes.length, failureCount: result.failures.length }
    } catch (error) {
        logger
            .withMetadata({ extras: { printEntry: entry } })
            .withError(error)
            .error()
        return rejectWithValue(getThunkRejectValue(error))
    }
})
